import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47d34db4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "personal-info"
};
const _hoisted_2 = {
  class: "personal-info-content"
};
const _hoisted_3 = ["src"];
import { CellCard, NavBar } from '@/components';
import { reactive, onMounted, getCurrentInstance, computed } from 'vue';
import { getUserInfoApi } from '@/api/personalInfo';
import { fullScreen, openLoginPage } from '@/utils/navitiveApi/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfo',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $loading,
      $alert
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    // 实名icon
    const verification_status_img = require('@/assets/image/verification-status.png');
    const verification_status_2_img = require('@/assets/image/verification-status_2.png');
    // 占位符文字
    const EMPTY_USER_TEXT = '实名后将自动显示';
    const EMPTY_CONTACT_TEXT = '未设置';
    // 用户信息
    const personalInfo = reactive({
      mobile: 13241020988
    });
    // 是否实名
    const verificationStatus = computed(() => {
      return personalInfo.realAuth === '1';
    });
    // 获取用户信息
    const initInfo = async () => {
      try {
        $loading.openLoading();
        const {
          code,
          message,
          data
        } = await getUserInfoApi();
        $loading.closeLoading();
        if (code !== 9000) {
          $alert({
            message
          }).then(() => {
            if (code === 9008) {
              openLoginPage();
            }
          });
          return;
        }
        Object.assign(personalInfo, data);
      } catch (error) {
        console.error(error.tarck());
      }
    };
    onMounted(() => {
      fullScreen();
      console.info('个人信息页面');
      initInfo();
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_cell = _resolveComponent("van-cell");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(NavBar), {
        title: "个人信息",
        "back-to-close": ""
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(CellCard), null, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "实名认证",
          style: {
            "align-items": "center"
          },
          "is-link": !_unref(verificationStatus),
          to: !_unref(verificationStatus) ? '/identityVerification?from=h5' : undefined
        }, {
          "right-icon": _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["verification-status", {
              'has-verification': _unref(verificationStatus)
            }])
          }, [_createElementVNode("img", {
            src: _unref(verificationStatus) ? _unref(verification_status_img) : _unref(verification_status_2_img),
            alt: ""
          }, null, 8, _hoisted_3), _createElementVNode("span", null, _toDisplayString(_unref(verificationStatus) ? '已实名' : '去实名'), 1)], 2), !_unref(verificationStatus) ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            class: "van-cell__right-icon",
            name: "arrow"
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["is-link", "to"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.name
          }),
          title: "姓 名",
          value: personalInfo.name || EMPTY_USER_TEXT
        }, null, 8, ["class", "value"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.idType
          }),
          title: "证件类型",
          value: personalInfo.idType || EMPTY_USER_TEXT
        }, null, 8, ["class", "value"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.idNo
          }),
          title: "证件号码",
          value: personalInfo.idNo || EMPTY_USER_TEXT
        }, null, 8, ["class", "value"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.gender
          }),
          title: "性 别",
          value: personalInfo.gender || EMPTY_USER_TEXT
        }, null, 8, ["class", "value"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.birth
          }),
          title: "出生日期",
          value: personalInfo.birth || EMPTY_USER_TEXT
        }, null, 8, ["class", "value"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.mobile
          }),
          title: "联系电话",
          value: personalInfo.mobile || EMPTY_CONTACT_TEXT,
          "is-link": "",
          to: 'personalInfoEdit?type=mobile&infoValue=' + (personalInfo.mobile || '')
        }, null, 8, ["class", "value", "to"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.email
          }),
          title: "电子邮箱",
          value: personalInfo.email || EMPTY_CONTACT_TEXT,
          "is-link": "",
          to: 'personalInfoEdit?type=email&infoValue=' + (personalInfo.email || '')
        }, null, 8, ["class", "value", "to"]), _createVNode(_component_van_cell, {
          class: _normalizeClass({
            'cell-palceholder': !personalInfo.fixPhone
          }),
          title: "固定电话",
          value: personalInfo.fixPhone || EMPTY_CONTACT_TEXT,
          "is-link": "",
          to: 'personalInfoEdit?type=fixPhone&infoValue=' + (personalInfo.fixPhone || '')
        }, null, 8, ["class", "value", "to"])]),
        _: 1
      })])]);
    };
  }
});